import EmailIcon from '@mui/icons-material/Email';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { BsTwitterX } from "react-icons/bs";
import "./footer.css";
import {
    FaFacebookF,
    FaLinkedinIn,
    FaInstagram,
} from "react-icons/fa";
const FooterSocial = () => {
    return (
        <div className="col-lg-3 col-md-3 footer_social_style mt-0">
            <a href="https://eventplanet.in">
                <button className="vendorButton mb-2 p-2" role="button">
                    <span>Switch To Website</span>
                </button>
            </a>
            <div className="social_link">
                <div className="link_item1 link_item">
                    <a href="https://www.facebook.com/event.planet.india/"><FaFacebookF size={18} className="icon_facebook"/></a>
                </div>
                <div className="link_item2 link_item">
                    <a href="https://mobile.twitter.com/eventplanet4"><BsTwitterX size={18} className="icon_twitter" /></a>
                </div>
                <div className="link_item3 link_item">
                    <a href="https://www.linkedin.com/company/event-planet-india/"><FaLinkedinIn size={18} className="icon_linkedin" /></a>
                </div>
                <div className="link_item4 link_item">
                    <a href="https://instagram.com/eventplanet_india?igshid=OGQ5ZDc2ODk2ZA=="><FaInstagram size={18} className="icon_instagram" /></a>
                </div>
                <div className="link_item5 link_item">
                    <a href="https://www.youtube.com/channel/UC4IKKm4irwJ1LFMEEZwoFzQ"><YouTubeIcon size={18} className="icon_youtube" /></a>
                </div>
            </div>
            <div className="consult_link">
                <p>Free Consultation with a Wedding Expert</p>
                <p>We’re here to help!</p>
            </div>
            <div className="phone_section">
                <a href="mailto:info.eventplanet.in" className="email_icon"><EmailIcon style={{ color: "#000" }} />&nbsp;&nbsp;info@eventplanet.in</a>
            </div>
        </div>
    );
};

export default FooterSocial;